import React from 'react'
import PleaseWait from 'components/PleaseWait'
import ErrorMessage from 'components/ErrorMessage'

const GroupTertiaryError = ({ error }) => {
  const errorMessage = error?.message || error
  if (
    errorMessage === 'access_denied' ||
    errorMessage === 'members_only' ||
    errorMessage === 'not_authorized'
  ) {
    return <PleaseWait i18nKey="group.only_visible_to_members" />
  } else {
    return <ErrorMessage i18nKey={errorMessage} />
  }
}

export default GroupTertiaryError
